import { __require as requireIsObject } from './node_modules-core-js-internals-is-object.js';

var isPossiblePrototype;
var hasRequiredIsPossiblePrototype;

function requireIsPossiblePrototype () {
	if (hasRequiredIsPossiblePrototype) return isPossiblePrototype;
	hasRequiredIsPossiblePrototype = 1;
	var isObject = requireIsObject();

	isPossiblePrototype = function (argument) {
	  return isObject(argument) || argument === null;
	};
	return isPossiblePrototype;
}

export { requireIsPossiblePrototype as __require };
//# sourceMappingURL=node_modules-core-js-internals-is-possible-prototype.js.map
